import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
      <span className="font-label text-6xl font-extrabold text-primary-500">404</span>
      <h1 className="mt-4 text-2xl font-semibold text-foreground-950">这个页面走丢了</h1>
      <p className="mt-3 text-sm text-foreground-600 max-w-md">
        你访问的页面可能已下线，或者链接输入有误。回到首页继续挑选想看的影片吧。
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
      >
        <i className="ri-home-4-line text-base w-4 h-4 flex items-center justify-center" />
        返回首页
      </Link>
    </div>
  );
}